import React from 'react'
import {makeStyles} from '@material-ui/styles'
import {joinClassNames} from '../../helpers/classname'

const useStyles = makeStyles({
  root: {
    fontFamily: '\'Coming Soon\', cursive',
    color: 'rgba(0,0,128, 0.8)',
    fontSize: '3em',
    fontKerning: 'none',
  },
})

export default function WrittenText({component = 'span', className, ...props}) {
  const {root} = useStyles()
  return React.createElement(component, {
    ...props,
    className: joinClassNames(root, className),
  })
}